import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

const initialState = {
    activeTab: 'book',
    isPackageTypePickerOpen: false,
    isServicePickerOpen: true,
}

export const calendarSettingsSlice = createSlice({
    name: 'calendarSettings',
    initialState,
    reducers: {
        setActiveTab: (state, action: PayloadAction<string>) => {
            state.activeTab = action.payload
        },
        setIsPackageTypePickerOpen: (state, action: PayloadAction<boolean>) => {
            state.isPackageTypePickerOpen = action.payload
        },
        setIsServicePickerOpen: (state, action: PayloadAction<boolean>) => {
            state.isServicePickerOpen = action.payload
        },
    },
})

export const {
    setActiveTab,
    setIsPackageTypePickerOpen,
    setIsServicePickerOpen,
} = calendarSettingsSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const getActiveTab = (state: RootState): string =>
    state.calendarSettings.activeTab
export const getIsPackageTypePickerOpen = (state: RootState): boolean =>
    state.calendarSettings.isPackageTypePickerOpen
export const getIsServicePickerOpen = (state: RootState): boolean =>
    state.calendarSettings.isServicePickerOpen
export default calendarSettingsSlice.reducer
